module.exports = __webpack_public_path__ + "img/icon_success@3x.51bf53ac.png";